import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { HttpHeaders } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../environments/environment';
import { getATVarTemp, getData, getPeriodosAT, getPropieties, setLimites } from '../mayores-depositantes/querys';

@Injectable({
  providedIn: 'root'
})
export class MayoresdepositantesService {

  constructor(private apollo: Apollo) { }

  /**
   * Obtiene los periodos disponibles para la plantilla de Alerta Temprana
   * @param headers Headers con el token de autenticación
   * @param idPlantilla ID de la plantilla
   * @returns Datos de evaluaciones
   */
  async getPeriodosAT(headers: HttpHeaders, idPlantilla: number = 7) {
    const { data } = await firstValueFrom(
      this.apollo.use(environment.api_alertaTemprana).watchQuery<any>({
        query: getPeriodosAT,
        context: { headers },
        variables: { idPlantilla }
      }).valueChanges
    );
    return data;
  }

  /**
   * Obtiene los datos de mayores depositantes (AHO_06, AHO_07, AHO_08)
   * @param headers Headers con el token de autenticación
   * @param periodo Periodo en formato YYYY-MM
   * @returns Datos de ahorros
   */
  async getData(headers: HttpHeaders, periodo: string) {
    const { data } = await firstValueFrom(
      this.apollo.use(environment.api_aleemaRiesgos).watchQuery<any>({
        query: getData,
        context: { headers },
        variables: { periodo }
      }).valueChanges
    );
    return data;
  }

  /**
   * Obtiene el detalle de una variable temporal de Alerta Temprana
   * @param headers Headers con el token de autenticación
   * @param idEvaluacion ID de la evaluación
   * @param idVarTemp ID de la variable temporal
   * @returns Detalle de la variable temporal
   */
  async getATVarTemp(headers: HttpHeaders, idEvaluacion: string, idVarTemp: string) {
    const { data } = await firstValueFrom(
      this.apollo.use(environment.api_alertaTemprana).watchQuery<any>({
        query: getATVarTemp,
        context: { headers },
        variables: { idEvaluacion, idVarTemp }
      }).valueChanges
    );
    return data;
  }

  /**
   * Obtiene las propiedades de ahorros para un periodo específico
   * @param headers Headers con el token de autenticación
   * @param institucionId ID de la institución
   * @param periodo Periodo en formato YYYY-MM
   * @returns Propiedades y límites de ahorros
   */
  async getPropiedades(headers: HttpHeaders, institucionId: string, periodo: string) {
    const { data } = await firstValueFrom(
      this.apollo.use(environment.api_aleemaRiesgos).watchQuery<any>({
        query: getPropieties,
        context: { headers },
        variables: { institucionId, periodo }
      }).valueChanges
    );
    return data;
  }

  /**
   * Establece o actualiza los límites de mayores depositantes
   * @param headers Headers con el token de autenticación
   * @param periodo Periodo en formato YYYY-MM
   * @param propiedades Objeto JSON con las propiedades y límites
   * @param institucionId ID de la institución
   * @returns Resultado de la mutación
   */
  async setLimites(headers: HttpHeaders, periodo: string, propiedades: any, institucionId: string) {
    const result = await firstValueFrom(
      this.apollo.use(environment.api_aleemaRiesgos).mutate({
        mutation: setLimites,
        context: { headers },
        variables: {
          periodo,
          propiedades,
          institucionId
        }
      })
    );
    return result;
  }
}